import { takeLatest, put, call } from 'redux-saga/effects';
import { AppTracking } from 'global/appTracking';
import {
  UserAvatarActions,
  getUserAvatarSuccess,
  uploadUserAvatarSuccess,
  uploadUserAvatarFail, getUserAvatarFail,
} from './actions';
import { getUserAvatarAPI, uploadUserAvatarAPI } from './api';

function* getUserAvatar() {
  try {
    const avatar = yield call(getUserAvatarAPI);
    yield put(getUserAvatarSuccess(avatar.url));
  } catch (e) {
    yield put(getUserAvatarFail(e.message));
  }
}

function* uploadUserAvatar({ payload }) {
  AppTracking.settingsEvent({ action: 'Change Avatar' });
  try {
    const avatar = yield call(uploadUserAvatarAPI, payload);
    yield put(uploadUserAvatarSuccess(avatar.link));
  } catch (e) {
    yield put(uploadUserAvatarFail(e.message));
  }
}

export const userAvatarEffects = [
  takeLatest(UserAvatarActions.GET_AVATAR, getUserAvatar),
  takeLatest(UserAvatarActions.UPLOAD_AVATAR, uploadUserAvatar),
];
